import { render, staticRenderFns } from "./CadastroFinanceiroBancos.vue?vue&type=template&id=191f244c&"
import script from "./CadastroFinanceiroBancos.vue?vue&type=script&lang=js&"
export * from "./CadastroFinanceiroBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports